/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'

import { EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import BadgeList from '../../../components/BadgeList'
import { type Budget } from '../../types'
import DetailsSection from '../../../components/DetailsSection'
import { getAlertThresholds } from '../utils'

type Props = {
  alerts: Budget['alerts']
}

const Thresholds: FunctionComponent<Props> = ({ alerts }) => (
  <DetailsSection
    title={
      <FormattedMessage
        id='billing.notifications.budgets.budget-details.notify-at.title'
        defaultMessage='Notify at'
      />
    }
  >
    <BadgeList items={getAlertThresholds(alerts)} />
    <EuiText size='s'>
      <FormattedMessage
        id='billing.notifications.budgets.budget-details.notify-at.suffix'
        defaultMessage='of budget amount'
      />
    </EuiText>
  </DetailsSection>
)

export default Thresholds
